import React from 'react';
import { IScrollData } from 'interfaces/IScrollData';
import { useUpdateTopPosition } from 'hooks/useUpdateTopPosition';

const BOTTOM_SPACE_RATIO = 0.4; // 0.X = X * 10 percent from bottom

export const useGameMessagePosition = (
    dynamicHeight: boolean,
    ref: React.MutableRefObject<HTMLDivElement>,
): number => {
    const getNewTopPosition = React.useCallback(
        (data: IScrollData): number => {
            const elementBox = ref.current.getBoundingClientRect();
            const top = Math.max(
                data.scrollY -
                    data.iFrameTopOffset +
                    data.height -
                    elementBox.height -
                    data.height * BOTTOM_SPACE_RATIO,
                0,
            );
            const minBottom =
                window.innerHeight - elementBox.height - data.height * BOTTOM_SPACE_RATIO;

            return Math.min(top, minBottom);
        },
        [dynamicHeight],
    );

    return useUpdateTopPosition(dynamicHeight, getNewTopPosition, ref, 100);
};
